<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="菜单名称：">
        <el-input v-model="dataForm.menuName" placeholder="名称" clearable></el-input>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button @click="addOrUpdateHandle()" type="primary">新增</el-button>
        <el-button type="success" @click="menuExcel()">导出Excel</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      row-key="id"
      :tree-props="{children: 'childs', hasChildren: 'hasChildren'}"
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 80px)" border stripe :header-cell-style="{background:'#FAFAFA'}" placement="top">
      <el-table-column
        prop="data.menuId"
        header-align="center"
        align="center"
        type="true"
        width="100px"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="data.menuName"
        header-align="center"
        align="center"
        label="名称">
      </el-table-column>
      <el-table-column
        prop="data.icon"
        header-align="center"
        align="center"
        label="图标">
        <template slot-scope="scope">
          <el-button v-if="scope.row.data.icon" circle :icon="scope.row.data.icon" size="medium"></el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="data.type"
        header-align="center"
        align="center"
        label="类型">
        <template slot-scope="scope">
          <el-button round v-if="scope.row.data.type == '0'" size="medium" type="primary">
            菜单
          </el-button>
          <el-button round v-if="scope.row.data.type == '1'" size="medium" type="success">
            按钮
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="data.parentId"
        header-align="center"
        align="center"
        label="上级菜单ID">
      </el-table-column>
      <el-table-column
        prop="data.url"
        header-align="center"
        align="center"
        label="URL">
      </el-table-column>
      <el-table-column
        prop="data.perms"
        header-align="center"
        align="center"
        label="权限标识">
      </el-table-column>
      <el-table-column
        prop="data.orderNum"
        header-align="center"
        align="center"
        label="排序">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="新增" placement="top">
            <el-button style="font-size: 18px;" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)"><i
              class="el-icon-plus"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button style="font-size: 18px;" type="text" size="small" @click="addOrUpdateHandle(scope.row)"><i
              class="el-icon-edit-outline"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button style="font-size: 18px;" type="text" size="small" @click="deleteHandle(scope.row.data.menuId)"
                       :disabled="scope.row.hasChild"><i class="el-icon-delete"></i></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './menu-add-or-update'
import {excel} from "@/utils";

export default {
  data() {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getDataList()
  },
  methods: {
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/menu/tree'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'menuName': this.dataForm.menuName
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.menuTree.childs;
        } else {
          this.dataList = []
        }
        this.dataListLoading = false
      })
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row)
      })
    },
    // 删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.menuId
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/menu/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //导出
    menuExcel() {
      excel("/menu/excel", "菜单信息-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'menuName': this.dataForm.menuName
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/parameters/menu.vue